// Third Party
import React from 'react';

// Utils
import { flagsConfig } from '../../../../utils/comparison/configs';
import { formatMessage } from '../../../../utils/i18n';

// Components
import WarningLabel from '../../../components/misc/WarningLabel';
import ConnectedPrivateComponent from '../../../components/PrivateComponent';

type Props = {
  warnings: string[];
};

const supportedWarnings = [flagsConfig.shelf_onShelfKYPPartiallyComplete.key, flagsConfig.shelf_partiallyOnShelf.key];

const ComparisonCardWarnings = ({ warnings }: Props) => {
  const filteredWarnings = supportedWarnings.filter(warning => warnings.includes(warning));
  return (
    <>
      {filteredWarnings.map((warning, index) => (
        <ConnectedPrivateComponent key={index} permissions={flagsConfig[warning].permissions}>
          {() => (
            <div className="comparison-card-warnings">
              <WarningLabel size="small" text={formatMessage(`Comparison.Table.ShelfStatuses.${flagsConfig[warning].key}`)} />
            </div>
          )}
        </ConnectedPrivateComponent>
      ))}
    </>
  );
};

export default React.memo(ComparisonCardWarnings);
